import Skeleton from '@carvana/ds-skeleton';
import { LoadingTile } from '@carvana/merch-tile';

type OwnProps = {
  hasBottomBorder?: boolean;
};

export default function LoadingVehicleCarousel({
  hasBottomBorder = false
}: OwnProps) {
  return (
    <div
      className="lg:px-4xl xl:max-w-[1352px]"
      data-testid="loading-vehicle-carousel"
    >
      {/* header */}
      <div className="px-2xl sm:px-4xl md:px-3xl lg:px-0">
        <Skeleton height="28px" width="200px" />
      </div>

      <div className="mt-3xl flex gap-2xl overflow-hidden px-2xl sm:px-4xl md:px-3xl lg:px-0">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="w-[300px] shrink-0 sm:w-[280px] lg:w-[300px]"
          >
            <LoadingTile />
          </div>
        ))}
      </div>

      {/* pagination dots */}
      <div className="mt-3xl flex justify-center">
        <Skeleton height="7px" width="80px" className="rounded-full" />
      </div>
      {hasBottomBorder && (
        <div className="m-2xl border-b border-b-border-subtle sm:mx-4xl sm:my-3xl md:mx-3xl lg:mx-0" />
      )}
    </div>
  );
}
